export default __webpack_public_path__ + "static/media/carouselRightNav.d3e1d0b8.svg";